// Маппер складов — raw snake_case → camelCase DTO

import type {
  WarehouseDto,
  WarehouseRaw,
  WarehouseFullDto,
  WarehouseFullRaw,
} from '../types/place.types';

export function mapWarehouse(raw: WarehouseRaw): WarehouseDto {
  return {
    id: raw.id,
    name: raw.name,
    code: raw.code,
  };
}

export function mapWarehouseFull(raw: WarehouseFullRaw): WarehouseFullDto {
  return {
    id: raw.id,
    code: raw.code,
    name: raw.name,
    address: raw.address,
    useAddressStorage: !!raw.use_address_storage,
    isActive: !!raw.is_active,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  };
}
